import { PriorityStringType } from 'src/app/views/dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { DataTransform } from '../dataTransform';
import { SortInfo } from '../sortInfo';
import { TransformRule } from '../transformRule';
import { TransformType } from '../transformType';

export class EventGroupNamerTransform extends DataTransform<EventGroupNamerTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.eventGroupNamer,nodeID);
      this.transformConfig = new EventGroupNamerTransformConfig();
    }

    static fromJSON(data: any): EventGroupNamerTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: EventGroupNamerTransform = Object.assign(new EventGroupNamerTransform(0, 0, '', ''), data);
        instance.transformConfig = EventGroupNamerTransformConfig.fromJSON(instance.transformConfig);

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class EventGroupNamerTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: number;
    transformType: TransformType;
    defSourceField: string;
    defTargetField: string;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    userField: string;
    timestampField: string;
    sampleStart: number;
    sampleEnd : number;
    defTimeout : number;
    runAll :boolean;
    missesNamed: string;
    delMisses :boolean;
    bufferRows : number;
    threads : number;
    searchWildCard: string;
    multiColumnTarget:boolean;
    spaceSeparator :boolean;
    removeRedundant :boolean;
    groupBy: string;
    orderField: string;
    isOpenField: string;
    isCloseField: string;
    addFields: string[];
    defContainsInclude: number;

    rules: EventGroupNamerTransformRule[];
    
    static fromJSON(data: any): EventGroupNamerTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: EventGroupNamerTransformConfig = Object.assign(new EventGroupNamerTransformConfig(), data);

        const rules: EventGroupNamerTransformRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = EventGroupNamerTransformRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.rules = rules;
        return instance;
    }
}

export class EventGroupNamerTransformRule extends TransformRule {
    sourceField: string;
    targetField: string;
    actionString?: string[];
    objectString?: string[];
    timeout = 1;
    includeAction: boolean;
    ignoreSpaces = false;
    matchCase = false;
    priorityString : PriorityStringType;

    static fromJSON(data: any): EventGroupNamerTransformRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: EventGroupNamerTransformRule = Object.assign(new EventGroupNamerTransformRule(), data);

        return instance;
    }
}